import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
  static targets = ['count', 'hide']

  declare readonly countTarget: HTMLElement
  declare readonly hasCountTarget: boolean
  declare readonly hasHideTarget: boolean
  declare readonly hideTarget: HTMLElement

  connect (): void {
    this.sync()
  }

  sync (): void {
    if (!this.hasCountTarget || !this.hasHideTarget) return

    window.requestAnimationFrame(() => {
      const expanded = this.element.dataset.toggleOpenValue === 'true'

      this.countTarget.classList.toggle('hidden', expanded)
      this.hideTarget.classList.toggle('hidden', !expanded)
    })
  }
}
